module.exports = __webpack_public_path__ + "static/img/eper_quality_en.6f2605a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/product-icon/eper_quality_en.png
// module id = RKLg
// module chunks = 71